import { css } from '@emotion/react'

import common from 'shared/styles'
import custom from 'shared/styles/custom.styles'

const styles = () => {
    return {
        button: css`
          width: auto !important;
          ${custom.button};
        `,
        contextContainer: css`
            ${common.flexJustityAlignCenter};
            height: 600px;
            width: 900px;
            @media (max-width:1000px) {
                height: 300px;
                width: 600px;
            },
        `,
    }
}

export default styles
